export enum IntentTypes {
    register = "register",
    updateMobilePepclub = "updateMobilePepclub",
    verifyMobilePartial = "verifyMobilePartial",
    login = "login",
    empty = "",
}